<template>
  <div class="invite-external-guests">
    <modal-header>Invite guests to Space</modal-header>
    <div class="body">
      Invite guests to this Space by copying the link or sending a direct email.
      <br/>All guest invitees will be able to enter the Space without approval.
    </div>
    <div class="content">
      <TextInput
        readonly
        inset
        :icon="require('@/assets/global-icons/copy.svg')"
        copyOnClick
        label="Click to copy Space's URL"
        v-model="inviteURL"
        :clickHandler="copyHandler"
      />
      <button @click="inviteGuestsByEmail" class="invite-email-button">
        <div class="invite-email-button__text">Invite guests via email</div>
        <div class="invite-email-button__icon"><img src="@/assets/global-icons/email.svg" aria-hidden="true" /></div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ModalHeader from '@/framework/modals/components/newModalHeader.vue';
import { TextInput } from '@/framework';
import InviteExternalSpaceGuestsByEmailModal from '@/components/modals/admin/InviteExternalSpaceGuestsByEmailModal.vue';

export default {
  components: { ModalHeader, TextInput },
  name: 'InviteExternalGuestsModal',
  computed: {
    ...mapGetters(['getCurrentAreaId']),
    inviteURL() {
      return `${location.origin}/space/${this.getCurrentAreaId}`
    }
  },
  methods: {
    ...mapActions(['modal/open', 'modal/close', 'analytics/inviteGuestToSpaceLink']),
    inviteGuestsByEmail() {
      this['modal/open']([InviteExternalSpaceGuestsByEmailModal])
    },
    copyHandler() {
      this['analytics/inviteGuestToSpaceLink']()
    }
  },
  async created() {
    this.$emit('modalSettings', {
      hasCloseButton: true
    })
  }
};
</script>

<style scoped lang="scss">
.invite-external-guests {
  min-height: 200px;
}

.invite-email-button {
  box-sizing: border-box;
  width: 100%;
  padding: 25px 15px 25px 15px;
  background-color: $grey-5;
  border: none;
  margin-top: 20px;
  border-radius: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.1s;
  &:hover {
    background-color: #4f4d4d;
  }

  &__text {
    flex-grow: 1;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    text-align: left;
  }

  &__icon {
    justify-self: flex-end;
    fill: white;
    width: 60px;

    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.body {
  color: $grey-1;
  margin-bottom: 20px;
}

.loading-icon-container {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
